export default __webpack_public_path__ + "static/Vumography-BG2-e2c9d53152e27be223d1cea8a32f5952.webp";